import {useMemo} from "react";
import {Area} from "recharts";
import {BaseChart, ChartComponent} from "./BaseChart";
import {TimeSeriesDataProps} from "../../../types/timeSeriesDataProps";
import {FieldResult} from "../../../types/domain/fieldResult";
import {useMeasureSystemUtils} from "../../../hooks/measureSystemUtilsHooks";
import {MeasureSystemUtils} from "../../../types/domain/measureSystemUtils";
import dayjs from "dayjs";
/**
 * ETAW Cumulative is the Madera chart
 */
export const EtawCumulativeChart: ChartComponent = ({data}) => {
    const msUtils = useMeasureSystemUtils();
    const chartData = useMemo(() => data.map((d) => mapFieldResultsToChartData(d, msUtils)), [data, msUtils]);

    return (
        <BaseChart
            title="ETAW Cumulative"
            yLabel={msUtils.getRainfallUnits()}
            data={chartData}
            helpPopoverTranslationKey="help.popover.fields.etaw_cumulative"
        >
            <Area
                type="monotone"
                dataKey="actualEvapotranspirationAppliedWaterCumulative"
                name="ETAW Cumulative"
                unit={msUtils.getRainfallUnits()}
                yAxisId="left"
                stroke="#A1AEE3"
                fill="#E2E7F8"
                strokeWidth={2}
                isAnimationActive={false}
            />
        </BaseChart>
    );
};

const mapFieldResultsToChartData = (r: FieldResult, msUtils: MeasureSystemUtils): DataProps => ({
    date: dayjs(r.date).toDate(),
    actualEvapotranspirationAppliedWaterCumulative: msUtils.getRainfall(
        r.aggregatedProps.actual_evapotranspiration_applied_water_cumulative,
    ),
});

export interface DataProps extends TimeSeriesDataProps {
    actualEvapotranspirationAppliedWaterCumulative: number;
}
